module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "personal-details"
  }, [_c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('h1', {
    staticClass: "text-left"
  }, [_vm._v("Personal details")]), _vm._v(" "), _c('b-form-group', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("First name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.first_name ? '' : 'Enter name'
    },
    model: {
      value: (_vm.formData.first_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "first_name", $$v)
      },
      expression: "formData.first_name"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Last name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.last_name ? '' : 'Enter last name'
    },
    model: {
      value: (_vm.formData.last_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "last_name", $$v)
      },
      expression: "formData.last_name"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    class: [(_vm.needFill && !_vm.formData.username && !_vm.formData.email) ? 'has-danger' : '', 'row']
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Username")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.username ? '' : 'Enter username'
    },
    model: {
      value: (_vm.formData.username),
      callback: function($$v) {
        _vm.$set(_vm.formData, "username", $$v)
      },
      expression: "formData.username"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (!_vm.needFill || _vm.formData.email.length == 0) ? '' : (!_vm.validateEmail(_vm.formData.email)) ? 'danger' : ''
    }
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.username && !_vm.formData.email) ? 'has-danger' : '', 'row']
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Email")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.email ? '' : 'Enter email',
      "state": (!_vm.needFill || _vm.formData.email.length == 0) ? '' : (!_vm.validateEmail(_vm.formData.email)) ? 'danger' : ''
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("UPN")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.upn ? '' : ''
    },
    model: {
      value: (_vm.formData.upn),
      callback: function($$v) {
        _vm.$set(_vm.formData, "upn", $$v)
      },
      expression: "formData.upn"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    class: [(_vm.needFill && (!_vm.formData.id && !_vm.formData.passwordForm)) ? 'has-danger' : '', 'row']
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Password")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "password",
      "placeholder": _vm.formData.passwordForm ? '' : 'Enter password'
    },
    model: {
      value: (_vm.formData.passwordForm),
      callback: function($$v) {
        _vm.$set(_vm.formData, "passwordForm", $$v)
      },
      expression: "formData.passwordForm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 small red",
    staticStyle: {
      "padding-top": "4px"
    }
  }, [_vm._v("\n        Minimum password requirements "), _c('br'), _vm._v("6 characters, one capital, one number\n      ")])], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.formData.passwordForm.length == 0) ? '' : (_vm.formData.confirmPassword != _vm.formData.passwordForm) ? 'danger' : 'success'
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Confirm Password")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2 ",
    attrs: {
      "type": "password",
      "placeholder": _vm.formData.confirmPassword ? '' : 'Enter password',
      "state": (_vm.formData.passwordForm.length == 0) ? '' : (_vm.formData.confirmPassword != _vm.formData.passwordForm) ? 'danger' : 'success'
    },
    model: {
      value: (_vm.formData.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.formData, "confirmPassword", $$v)
      },
      expression: "formData.confirmPassword"
    }
  })], 1)]), _vm._v(" "), (_vm.type == 'admin') ? _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('b-form-select', {
    staticClass: "col-md-2",
    attrs: {
      "options": _vm.roles
    },
    model: {
      value: (_vm.formData.role),
      callback: function($$v) {
        _vm.$set(_vm.formData, "role", $$v)
      },
      expression: "formData.role"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('p', [_c('b', [_vm._v("Profile image")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "file-select"
  }, [_vm._v("\n            Select an image to upload\n            "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileChange($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    class: _vm.formData.img ? 'img-icon' : 'img-icon-empty',
    attrs: {
      "id": "icon-frame"
    }
  }, [(_vm.formData.img) ? [_c('img', {
    staticClass: "img-thumbnail",
    attrs: {
      "id": "icon",
      "src": _vm.formData.img
    }
  })] : _vm._e()], 2)])])]), _vm._v(" "), (_vm.formData.role != 'manager') ? [_c('h1', {
    staticClass: "text-left access-level"
  }, [_vm._v("Access level")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggest": _vm.suggestArea,
      "anchor": "name",
      "process": _vm.processJSON,
      "on-select": _vm.getDataSearchArea
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 offset-md-1"
  }, [_c('div', {
    staticClass: " work-areas__area-checkbox"
  }, [_c('area-checkbox', {
    attrs: {
      "type": "checkbox",
      "areas": _vm.areas,
      "baseId": "areaCheckbox-",
      "selected": _vm.areasChecked
    },
    model: {
      value: (_vm.areasChecked),
      callback: function($$v) {
        _vm.areasChecked = $$v
      },
      expression: "areasChecked"
    }
  })], 1)])])] : _vm._e(), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.areasChecked.length) ? 'has-danger' : '', 'line']
  }, [(_vm.formData.role != 'manager') ? [_vm._m(2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "selected-areas"
  }, _vm._l((_vm.areasChecked), function(item) {
    return _c('p', [_vm._v(_vm._s(item.name))])
  }), 0)])] : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "success"
    },
    on: {
      "click": _vm.submitUser
    }
  }, [(!_vm.formData.id) ? _c('span', [_vm._v("Add " + _vm._s(_vm.type == 'admin' ? 'admin' : 'user'))]) : _c('span', [_vm._v("Save")])]), _vm._v(" "), (_vm.formData.id && _vm.mustDelete) ? _c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.confirm_delete.show()
      }
    }
  }, [_vm._v("\n      Delete\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('b-modal', {
    ref: "user_added",
    attrs: {
      "title": ""
    },
    on: {
      "ok": function($event) {
        return _vm.returnBack()
      },
      "hide": function($event) {
        return _vm.returnBack()
      }
    }
  }, [_vm._v("\n    User "), (!_vm.$route.params.userId) ? _c('span', [_vm._v("created")]) : _c('span', [_vm._v("changed")])]), _vm._v(" "), _c('b-modal', {
    ref: "confirm_delete",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n    Are you sure you want to delete this user?\n    "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.onClickDelete()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.confirm_delete.hide();
      }
    }
  }, [_vm._v("No")])], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "assign_to_user",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n    Please, select a user to whom all open actions of the deleted user will be transferred\n    "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.usersListOptions
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        _vm.deleteUser(_vm.formData.id);
        _vm.$refs.assign_to_user.hide();
      }
    }
  }, [_vm._v("Assign")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.assign_to_user.hide();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Search working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Selected working areas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-123a627a","hasScoped":false}!./src/components/addUser/personalDetails/personalDetails.component.html
// module id = 535
// module chunks = 1